/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModuleItem_item = {
    readonly title: string | null;
    readonly imageUrl: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly " $refType": "HpRespCollectionsModuleItem_item";
};
export type HpRespCollectionsModuleItem_item$data = HpRespCollectionsModuleItem_item;
export type HpRespCollectionsModuleItem_item$key = {
    readonly " $data"?: HpRespCollectionsModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespCollectionsModuleItem_item",
  "type": "Product",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "imageUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'bd26ca7a69e100c0643049b577ff3e4f';
export default node;
